// ============================================================
// clientExports.js — Platform-07 termination-export bindings.
//
// Backend handlers:
//   admin-clients-exports-create.js       POST  /mgmt/admin/clients/{id}/exports
//   admin-clients-exports-list.js         GET   /mgmt/admin/clients/{id}/exports
//   admin-clients-exports-download.js     GET   /mgmt/admin/clients/{id}/exports/{exportId}/download
//   admin-clients-exports-acknowledge.js  POST  /mgmt/admin/clients/{id}/exports/{exportId}/acknowledge
//
// NOTE paths start '/mgmt/...' — API_BASE_URL already ends '/carehub/api'
// (apiPathConvention.test.js guards this file automatically).
// ============================================================
import { apiGet, apiPost } from './client';

export const listClientExports = (clientId) => apiGet(`/mgmt/admin/clients/${encodeURIComponent(clientId)}/exports`);

export const requestClientExport = (clientId) => apiPost(`/mgmt/admin/clients/${encodeURIComponent(clientId)}/exports`, {});

export const getClientExportDownload = (clientId, exportId) => apiGet(
  `/mgmt/admin/clients/${encodeURIComponent(clientId)}/exports/${encodeURIComponent(exportId)}/download`,
);

export const acknowledgeClientExport = (clientId, exportId, note) => apiPost(
  `/mgmt/admin/clients/${encodeURIComponent(clientId)}/exports/${encodeURIComponent(exportId)}/acknowledge`,
  { note },
);

// Formatting helper co-located with the binding (billing.js precedent).
export function formatSize(bytes) {
  if (bytes == null) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}
